module.exports = __webpack_public_path__ + "static/img/cloud.84286ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/cloud.png
// module id = VTc5
// module chunks = 0